<template>
  <pt-integral-exchange-table class="pt-integral-exchange-table__withData" @getIntegralExchangeList="getIntegralExchangeList" :tableLabels="tableLabels" :page-size="page_size" :tableData="tableData"
  :totalNumber="totalNumber" ref="table" :loading="loading">
      <slot/>
  </pt-integral-exchange-table>
</template>

<script>
import PtIntegralExchangeTable from './index'
export default {
  name: 'pt-integral-exchange-table__withData',
  components: {
    'pt-integral-exchange-table': PtIntegralExchangeTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      totalNumber: 0,
      page_size: 10,
      tableData: [],
      loading: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getIntegralExchangeList(this.page)
      }
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getIntegralExchangeList (page, next, size) {
      if (this.paramsData.memberLevel) {
        this.paramsData.memberLevel = Number(this.paramsData.memberLevel)
      }
      let data = {
        pageable: {
          page: page,
          size: size || this.page_size,
          sort: 'createdDate,desc'
        },
        ...this.paramsData
      }
      this.loading = true
      this.$store.dispatch('getIntegralExchangeList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取失败')
        this.$refs.table.showReTry()
        this.loading = false
      })
    },
    reload () {
      this.$refs.table.reload()
    }
  }
}
</script>
